module.exports = "/_next/static/images/IEEE-guide-hero-06fe5b8b3a1a27f39d6e73c7f07b59cc.png";